<template>
  <ValidationObserver
    class="question single-answer-matrix column is-10"
    tag="div"
    v-slot="{ errors }"
  >
    <div class="question-text">
      <p class="help is-danger" v-if="errors[0]">{{ errors[0] }}</p>
    </div>
    <div class="question-content card">
      <div class="card-content">
        <div class="is-desktop" v-if="!showMobileView">
          <template v-if="categories">
            <table class="table is-hidden-touch block-randomization">
              <colgroup>
                <col :key="index" :width="colWidth(index)" v-for="index in cols" />
              </colgroup>
              <tr class="border-0 sticky-header" >
                <td></td>
                <td
                  :key="answer.id"
                  v-for="answer in question.answers"
                  v-html="answer.answer[lang]"
                ></td>
              </tr>
              <template v-for="(category, index) in categories">
                  <tr class="category-title" v-if="category.display_title && category.sub_questions.length > 0" :key="`block-${index}`">
                    <td :colspan="question.answers.length + 1">{{ category.title[lang] || Object.values(category.title)[0] }}</td>
                  </tr>
                  <ValidationProvider
                    :key="subQuestion.id"
                    :ref="`desktopProvider${getIndex(subQuestion._id)}`"
                    :rules="validationRules"
                    tag="tr"
                    v-for="subQuestion in category.sub_questions"
                    v-slot="{ errors }"
                  >
                    <td :class="{ 'has-text-danger has-text-weight-bold': errors[0] }">
                      <div v-html="subQuestion.question[lang]"></div>
                    </td>
                    <td :key="answer.id" v-for="answer in question.answers">
                      <b-radio
                        :disabled="shouldDisable(questionKey(question.qid, subQuestion.code, answer.code))"
                        :native-value="answer.code"
                        :value="value[questionKey(question.qid, subQuestion.code)]"
                        @input="
                          onChange(questionKey(question.qid, subQuestion.code), $event)
                        "
                      >
                      </b-radio>
                    </td>
                  </ValidationProvider>
              </template>
            </table>
          </template>
          <template v-else>
            <table class="table is-hidden-touch">
              <colgroup>
                <col :key="index" :width="colWidth(index)" v-for="index in cols" />
              </colgroup>
              <tr class="sticky-header">
                <td></td>
                <td
                  :key="answer.id"
                  v-for="answer in question.answers"
                  v-html="answer.answer[lang]"
                ></td>
              </tr>
              <ValidationProvider
                :key="subQuestion.id"
                :ref="`desktopProvider${index}`"
                :rules="validationRules"
                tag="tr"
                v-for="(subQuestion, index) in question.sub_questions"
                v-slot="{ errors }"
              >
                <td :class="{ 'has-text-danger has-text-weight-bold': errors[0] }">
                  <div v-html="subQuestion.question[lang]"></div>
                </td>
                <td :key="answer.id" v-for="answer in question.answers">
                  <b-radio
                    :disabled="shouldDisable(questionKey(question.qid, subQuestion.code, answer.code))"
                    :native-value="answer.code"
                    :value="value[questionKey(question.qid, subQuestion.code)]"
                    @input="
                      onChange(questionKey(question.qid, subQuestion.code), $event)
                    "
                  >
                  </b-radio>
                </td>
              </ValidationProvider>
            </table>
          </template>
        </div>

        <div class="is-mobile" :class="{'is-hidden-desktop' : !showMobileView, 'show-as-mobile-view': showMobileView}">
          <template v-if="categories">
            <div :key="index" v-for="(category, index) in categories" class="category-content">
              <p v-if="category.display_title && category.sub_questions.length > 0" class="category-title">{{ category.title[lang] || Object.values(category.title)[0] }}</p>
                <b-collapse
                  :ref="`collapse${getIndex(subQuestion._id)}`"
                  :key="`collapse-${getIndex(subQuestion._id)}`"
                  :open="isOpen === getIndex(subQuestion._id)"
                  @open="openCollapse(getIndex(subQuestion._id))"
                  animation="slide"
                  class="card p-2 mb-2"
                  v-for="(subQuestion) in category.sub_questions"
                >
                  <template #trigger="props">
                    <div
                      :class="{ active: props.open, 'has-error': hasError(getIndex(subQuestion._id)) }"
                      class="card-header"
                      role="button"
                    >
                      <div class="card-header-control">
                        <p
                          class="card-header-title"
                          v-html="subQuestion.question[lang]"
                        ></p>
                        <a class="card-header-icon">
                          <b-icon :icon="props.open ? 'menu-down' : 'menu-up'">
                          </b-icon>
                        </a>
                      </div>
                      <div
                        class="selected-option"
                        v-if="
                          !props.open &&
                            selectedValue(
                              value[questionKey(question.qid, subQuestion.code)]
                            ) !== ''
                        "
                      >
                        <b-icon icon="check"></b-icon>
												<span v-html="selectedValue(value[questionKey(question.qid, subQuestion.code)])"></span>
                      </div>
                    </div>
                  </template>
                  <ValidationProvider
                    :key="subQuestion.id"
                    :ref="`mobileProvider${getIndex(subQuestion._id)}`"
                    :rules="validationRules"
                    class="card-content"
                    tag="div"
                  >
                    <div class="content">
                      <b-field
                        :key="answer.id"
                        class="mb-4"
                        v-for="answer in question.answers"
                      >
                        <b-radio
                          :disabled="shouldDisable(questionKey(question.qid, subQuestion.code, answer.code))"
                          :native-value="answer.code"
                          :value="value[questionKey(question.qid, subQuestion.code)]"
                          @input="
                            onChange(
                              questionKey(question.qid, subQuestion.code),
                              $event
                            )
                          "
                        >
                          <span v-html="answer.answer[lang]"></span>
                        </b-radio>
                      </b-field>
                    </div>
                  </ValidationProvider>
                </b-collapse>
            </div>
          </template>
          <template v-else>
              <b-collapse
                :ref="`collapse${index}`"
                :key="`collapse-${index}`"
                :open="isOpen === index"
                @open="openCollapse(index)"
                animation="slide"
                class="card p-2 mb-2"
                v-for="(subQuestion, index) in question.sub_questions"
              >
                <template #trigger="props">
                  <div
                    :class="{ active: props.open, 'has-error': hasError(index) }"
                    class="card-header"
                    role="button"
                  >
                    <div class="card-header-control">
                      <p
                        class="card-header-title"
                        v-html="subQuestion.question[lang]"
                      ></p>
                      <a class="card-header-icon">
                        <b-icon :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                      </a>
                    </div>
                    <div
                      class="selected-option"
                      v-if="
                        !props.open &&
                          selectedValue(
                            value[questionKey(question.qid, subQuestion.code)]
                          ) !== ''
                      "
                    >
                      <b-icon icon="check"></b-icon>
											<span v-html="selectedValue(value[questionKey(question.qid, subQuestion.code)])"></span>
                    </div>
                  </div>
                </template>
                <ValidationProvider
                  :key="subQuestion.id"
                  :ref="`mobileProvider${index}`"
                  :rules="validationRules"
                  class="card-content"
                  tag="div"
                >
                  <div class="content">
                    <b-field
                      :key="answer.id"
                      class="mb-4"
                      v-for="answer in question.answers"
                    >
                      <b-radio
                        :disabled="shouldDisable(questionKey(question.qid, subQuestion.code, answer.code))"
                        :native-value="answer.code"
                        :value="value[questionKey(question.qid, subQuestion.code)]"
                        @input="
                          onChange(
                            questionKey(question.qid, subQuestion.code),
                            $event
                          )
                        "
                      >
                        <span v-html="answer.answer[lang]"></span>
                      </b-radio>
                    </b-field>
                  </div>
                </ValidationProvider>
              </b-collapse>
          </template>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>
<script>
import { QuestionMixin } from "@/mixins/question";
import { BlockRandomizationMixin } from "@/mixins/block-randomization";

export default {
  name: "SingleAnswerMatrix",
  mixins: [QuestionMixin, BlockRandomizationMixin],
  data() {
    return {
      isOpen: 0,
      showMobileView: false,
      disabled: [],
    };
  },
  methods: {
    shouldDisable(answer){
      if(this.loading) return true;
      return this.disabled.includes(answer);
    },
    colWidth(index) {
      if (index === 1) return '25%'
      return `${Math.round(75 / this.cols)}%`;
    },
    onChange(key, value) {
      this.isOpen++;
      this.$emit("input", { [key]: `${value}` });
      const el = this.$refs[`collapse${this.isOpen}`];
      if (el) {
        el[0]?.toggle();
      }
      this.validateRow(key.split("_")[1], `${value}`);
    },
    // vee-validate wires its listeners to the first input node of a provider only, and
    // these <b-radio> nodes carry no v-model of their own, so no column ever triggers a
    // full validation on its own — the row stays silent until the form is submitted.
    // The row and its new value are both known here, so validate it explicitly.
    validateRow(sqcode, value) {
      const index = this.rowIndex(sqcode);
      if (index < 0) return;
      [`desktopProvider${index}`, `mobileProvider${index}`].forEach((name) => {
        const ref = this.$refs[name];
        const provider = Array.isArray(ref) ? ref[0] : ref;
        if (provider) provider.validate(value);
      });
    },
    rowIndex(sqcode) {
      const subQuestions = this.categories
        ? this.flattenCategory
        : this.question.sub_questions;
      return subQuestions.findIndex((subQuestion) => subQuestion.code === sqcode);
    },
    getFirstError(errors) {
      const firstExistsErrors = Object.values(errors).find((item) => item[0]);
      if (firstExistsErrors) return firstExistsErrors[0];
    },
    hasError(index) {
      let provider = this.$refs[`mobileProvider${index}`];
      if (!provider) return false;
      return provider[0].errors.length >= 1;
    },
    selectedValue(value) {
      let answer = this.question.answers.find((answer) => {
        return answer.code === value;
      });
      if (!answer) return "";
      return answer.answer[this.lang];
    },
    openCollapse(index) {
      this.isOpen = index;
      const el = this.$refs[`collapse${index}`];
      if (el) {
        window.setTimeout(function () {
          el[0].$el.scrollIntoView({ behavior: "smooth", block: "center"});
          // el[0].$el.scrollIntoView({ behavior: "smooth", block: "end"});
        }, 200)
      }
    },
    getIndex(id) {
      return this.flattenCategory.findIndex(item => item._id === id);
    }
  },
  computed: {
    cols() {
      return this.question.answers.length + 1;
    },
    flattenCategory() {
      return this.categories?.flatMap(item => item.sub_questions);
    }
  },
  mounted() {
    this.$emit("mounted", "is-10");
  },
};
</script>
<style lang="scss">
.single-answer-matrix {
  color: #595959;

  .b-radio.radio {
    margin-right: 0;

    .control-label {
      @include from($desktop) {
        // display: none;
      }
    }
  }

  table {
    td:not(:first-child) {
      text-align: center;
    }

    tr:not(:first-child) {
      td:not(:first-child) {
        vertical-align: middle;
      }
    }

    tr:not(.border-0):not(.category-title) {
      border-top: 1px solid #dbdbdb;
    }

    tr:last-child td {
      border-bottom: none;
    }

    &.block-randomization tr {
      &:last-child {
        border-bottom: 1px solid #dbdbdb;
      }

      &.border-0,
      &.border-0 td {
        border-bottom: none !important;
      }
    }
  }

  .is-mobile {
    .card-header {
      border-bottom: 1px solid $gray-4;
      box-shadow: none;
      flex-direction: column;
      border-radius: 0;

      &.has-error {
        color: $red;
        border-bottom: 1px solid $red;

        .card-header-title,
        .icon {
          color: $red;
        }
      }

      &.active {
        border: none;
      }

      .card-header-control {
        display: flex;
      }

      .card-header-title {
        color: $gray-10;
				display: block;
        font-weight: 500;
        font-size: 1rem;
        line-height: 22px;
        padding: 0.75rem 0;
      }

      .card-header-icon {
        padding: 0.75rem 0;
      }

      .selected-option {
        margin-bottom: 1rem;
        color: $primary;
        display: flex;
      }
    }

    .card-content {
      margin-top: 1.5rem;

      .content {
        .field {
          border: 1px solid $gray-4;
          padding: 0.5rem 1rem;
          display: flex;
        }
      }
    }

    .category-title {
      padding-bottom: 5px;
      border-bottom: 1px solid #dbdbdb;
    }
  }
}
.sticky-header {
  position: sticky;
  top: 0;
  background-color: white;
  margin-left: -20px;
  z-index: 999;
}
</style>
